// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  // URL_SERVICIO: 'http://192.168.18.10:8000/api',
  // KEY_CRY: '123456',
  // ENCRYPT_ENABLED: false, // Activar/desactivar encriptación
  URL_SERVICIO: 'https://qhse-ws-qa.wydnex.com/api',
  KEY_CRY: '123456',
  ENCRYPT_ENABLED: true, // Activar/desactivar encriptación
  URL_SOCKET:'https://qhse-node-qa.wydnex.com'

};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
